import React, { useContext, useEffect, useState } from 'react';
import '../classes/styles/style.css';
import Header from '../components/header';
import Sidenav from '../components/sidenav';
import { useNavigate } from 'react-router';
import { GlobalContextData, GetGlobalContext } from '../classes/context';
import SidenavMobile from './sidenavMobile';

export default function Screen({ children }: { children: React.ReactNode }): JSX.Element {
    const [isSidenavHidden, setSidenavHidden] = useState(false);
    const [isSidenavMobileHidden, setSidenavMobileHidden] = useState(true);
    const globalContext = useContext<GlobalContextData>(GetGlobalContext);
    const navigate = useNavigate();
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

    const toggleSidenav = () => {
        if (isMobile){
            setSidenavMobileHidden((isSidenavMobileHidden) => !isSidenavMobileHidden)
        }else{
            setSidenavHidden(!isSidenavHidden);
        }

    };

    const toggleSidenavMobile = () => {
        setSidenavMobileHidden((prev) => !prev);
    };

    useEffect(() => {
        if (!globalContext.vars.esercente)
            navigate('/');
    }, []);

    return (
        <div className='wrapper-body' >
            <Sidenav isHidden={isSidenavHidden} />
            <SidenavMobile isHidden={isSidenavMobileHidden} onToggle={toggleSidenavMobile} />
            <div className='body-container'>
                <Header onToggleSidenav={toggleSidenav} user={globalContext.vars.esercente?.RagSoc} />
                <div className='main-layout'>
                    {children}
                </div>
            </div>
        </div>
    );
}